import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../services/apiService";
import { useFeaturedCars } from "../../hooks/useFeaturedCars";
import "../login.css";
import logo from "../assets/trustauto-logo.png";
import carImage1 from "../assets/car_image_1.svg";
import carImage2 from "../assets/car_image_2.svg";

const DriverLogin = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true); // New state for auto-sliding
  const { images } = useFeaturedCars();
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("userRole");
    if (authToken && userRole === "delivery_driver") {
      navigate("/driverHome", { replace: true });
    }
  }, [navigate]);

  // Automatic image sliding
  useEffect(() => {
    if (!isAutoSliding) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isAutoSliding, images.length]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const mobile = e.target.mobile.value;

    try {
      setLoading(true);
      setError("");

      const response = await apiService.sendOTP({
        phoneNumber: mobile,
      });

      if (!response) {
        throw new Error("No response received from server");
      }

      if (response.status === 200 && response.data.success) {
        console.log("OTP sent successfully:", response.data);
        localStorage.setItem("otpToken", response.data.otpToken);
        localStorage.setItem("tempRegNumber", mobile);
        navigate("/otp", { state: { role: "delivery_driver" }, replace: true });
      } else if (response.status === 403) {
        setError(response.data.error || "No valid OTP access found. Please contact an administrator.");
      } else {
        setError(response.data.error || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      const errorMessage = error.response?.data?.error || error.message || "Failed to send OTP";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevImage = () => {
    setIsAutoSliding(false); // Pause auto-sliding
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    setTimeout(() => setIsAutoSliding(true), 5000); // Resume after 5 seconds
  };

  const handleNextImage = () => {
    setIsAutoSliding(false); // Pause auto-sliding
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
    setTimeout(() => setIsAutoSliding(true), 5000); // Resume after 5 seconds
  };

  const handleDotClick = (index) => {
    setIsAutoSliding(false); // Pause auto-sliding
    setCurrentImageIndex(index);
    setTimeout(() => setIsAutoSliding(true), 5000); // Resume after 5 seconds
  };

  return (
    <div className="wrap_login">
      <div className="login">
        <div className="container">
          <div className="left-part">
            <div className="left-part-content">
              <div className="welcome-msg">
                <h1>Login as Driver</h1>
                <p>Login now to access Trust Auction Platform</p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="inputs">
                  <label className="mobile">Mobile Number</label>
                  <input
                    type="number"
                    name="mobile"
                    placeholder="+91 99999 99999"
                    required
                  />
                  <label className="captcha">Captcha</label>
                  <div className="captcha-input-box">
                    <input
                      type="checkbox"
                      name="human"
                      className="captcha-input"
                    />
                    <label htmlFor="human">Are you a Human?</label>
                  </div>
                </div>
                <div className="auth-msg">
                  <p>We will send an OTP to your Mobile Number</p>
                </div>
                {error && <p className="error-message">⚠️ {error}</p>}
                <div className="buttons">
                  <button className="signIn" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Login"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="right-part">
            <div className="right-part-content">
              <div className="images">
                <div className="carousel">
                  <div className="dots">
                    {images.map((_, index) => (
                      <span
                        key={index}
                        className={`dot ${currentImageIndex === index ? "active" : ""}`}
                        onClick={() => handleDotClick(index)}
                      ></span>
                    ))}
                  </div>
                  <div className="carousel-track" style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}>
                    {images.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="Car"
                        className="carImage"
                        onError={(e) => {
                          // Fallback to default images if featured image fails to load
                          const defaultImages = [carImage1, carImage2, carImage2];
                          e.target.src = defaultImages[index % defaultImages.length];
                        }}
                      />
                    ))}
                  </div>
                  <div className="carousel-controls">
                    <button
                      className="carousel-button prev"
                      onClick={handlePrevImage}
                    >
                      <span>&lt;</span>
                    </button>
                    <button
                      className="carousel-button next"
                      onClick={handleNextImage}
                    >
                      <span>&gt;</span>
                    </button>
                  </div>
                  <div className="image-content">
                    <h2>Cars In Auction Today</h2>
                    <p>Bid Bold. Drive Trusted</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverLogin;